<div class="col-span-12 md:col-span-12 w-full">
  <div class="flex justify-start items-center space-x-1 mb-2">
    <span *ngIf="required" class="text-lg text-red-500 font-bold mr-1">*</span>
    <label [for]="controlName" class="text-sm font-medium text-gray-700 dark:text-primary-100">{{ label }}</label>
    <app-info-tooltip *ngIf="tooltip"
                      [tooltip]="tooltip"
                      [tooltipPosition]="tooltipPosition"
                      [tooltipClass]="tooltipClass">
    </app-info-tooltip>
  </div>

  <div class="relative">
    <!-- Text Input -->
    <input
      *ngIf="type !== 'textarea'"
      [type]="type"
      [id]="controlName"
      [formControlName]="controlName"
      [attr.maxlength]="maxlength"
      [attr.aria-describedby]="showCounter ? controlName + '-counter' : null"
      [required]="required"
      class="input disabled:bg-gray-100 dark:disabled:bg-transparent"
      [class.pr-10]="showIcon"
      [placeholder]="placeholder"
    />

    <!-- Textarea -->
    <textarea
      *ngIf="type === 'textarea'"
      [id]="controlName"
      [formControlName]="controlName"
      [attr.maxlength]="maxlength"
      [attr.aria-describedby]="showCounter ? controlName + '-counter' : null"
      [required]="required"
      class="input disabled:bg-gray-100 dark:disabled:bg-transparent resize-y min-h-[100px]"
      [class.pr-10]="showIcon"
      [placeholder]="placeholder"
      rows="4"
    ></textarea>

    <div *ngIf="showIcon" class="hidden md:block absolute top-1/2 -translate-y-1/2" style="right: -30px;">
      <svg *ngIf="hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 stroke-2 text-green-500">
        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
      </svg>
      <svg *ngIf="!hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 text-amber-500">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
      </svg>
    </div>
  </div>

  <div class="pt-1 flex items-start justify-between gap-3"
       *ngIf="showCounter || (formControl.touched && formControl.invalid)">
    <div class="flex-1 min-w-0">
      <ng-container *ngIf="formControl.touched && formControl.invalid">
        <div class="ng-invalid input-error" *ngIf="formControl.errors?.['required']">
          {{ label }} field is required.
        </div>
        <div class="ng-invalid input-error" *ngIf="formControl.errors?.['maxlength']">
          {{ label }} cannot exceed {{ maxlength }} characters.
        </div>
        <div class="ng-invalid input-error" *ngIf="formControl.errors?.['pattern']">
          {{ patternErrorMessage }}
        </div>
      </ng-container>
    </div>

    <div *ngIf="showCounter"
         data-testid="character-counter"
         class="text-xs flex-shrink-0 tabular-nums"
         [ngClass]="counterClass"
         aria-hidden="true">
      {{ characterCount }} / {{ maxlength }}
    </div>
  </div>

  <!-- Target of aria-describedby: static, so focusing the field states the limit without announcing a live count. -->
  <div *ngIf="showCounter" [id]="controlName + '-counter'" class="sr-only">
    {{ maxlength }} characters maximum.
  </div>

  <div *ngIf="showCounter" class="sr-only" role="status" aria-live="polite">
    {{ counterAnnouncement }}
  </div>
</div>
